import { help } from "../../constants/actionTypes";

const INITIAL_STATE = {
  apiDocData: "",
  errorData: "",
};

const helpReducer = (state = INITIAL_STATE, action = {}) => {
  switch (action.type) {
    case help?.SUCCESS_API_DOC:
      return {
        ...state,
        apiDocData: action?.payload?.data,
      };

    case help?.ERROR_API_DOC:
      return {
        ...state,
        errorData: action?.payload,
      };

    default:
      return state;
  }
};

export default helpReducer;
